import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { DisplayText, IllusEmpty_2, Image, theme } from '@sg/garnish';

export const CreditCardFormErrorState = () => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.wrapper}>
      <Image source={IllusEmpty_2} style={styles.illustration} />

      <DisplayText
        size={4}
        style={styles.heading}
        testID="error-boundary-fallback-title"
      >
        {formatMessage(messages.error)}
      </DisplayText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing['8'],
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
  illustration: {
    width: 150,
    height: 150,
    alignSelf: 'center',
  },
  heading: {
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  error: {
    defaultMessage: 'Something went wrong, try again in a few moments...',
    description: 'Credit Card Form Error State | Error title',
  },
});
